module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av190-6d0f808c7267628b7e5d88f62ac27deb.jpg";